import { render, staticRenderFns } from "./FlightDetailsSummary.vue?vue&type=template&id=06b720e6&"
import script from "./FlightDetailsSummary.vue?vue&type=script&lang=js&"
export * from "./FlightDetailsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports